import { createRoot } from 'react-dom/client';
import './widget.css';
import { WidgetApp } from './WidgetApp';
import { readEnv } from './wix';

// No StrictMode: its doubled effects in development would double the API and
// registration calls, and the Playwright tests should see what visitors get.
createRoot(document.getElementById('root')!).render(<WidgetApp env={readEnv()} />);
